export const PINATA_IPFS_GATEWAY = "https://gateway.pinata.cloud/ipfs";

/** Public gateways that often 403 / interstitial in the browser. Pinata serves the same CID. */
const FLAKY_IPFS_GATEWAY_HOSTS = new Set([
  "ipfs.io",
  "www.ipfs.io",
  "gateway.ipfs.io",
  "cloudflare-ipfs.com",
  "cf-ipfs.com",
  "dweb.link",
  "nftstorage.link",
  "w3s.link",
]);

/**
 * ipfs.io GET with a browser UA is frequently a Cloudflare interstitial (not the image).
 * Pinata's gateway serves the same CID without that challenge.
 * Also maps `ipfs://<cid>` onto Pinata.
 * @param {unknown} value
 * @returns {string | null | undefined}
 */
export function rewriteFlakyIpfsGatewayUrl(value) {
  if (typeof value !== "string") return value;
  const urlString = value.trim();
  if (!urlString) return value;

  if (/^ipfs:\/\//i.test(urlString)) {
    const cid = urlString.slice("ipfs://".length).replace(/^ipfs\//i, "");
    return cid ? `${PINATA_IPFS_GATEWAY}/${cid}` : urlString;
  }

  try {
    const u = new URL(urlString);
    const host = u.hostname.toLowerCase();
    const pathMatch = u.pathname.match(/^\/ipfs\/(.+)$/i);
    if (pathMatch?.[1] && FLAKY_IPFS_GATEWAY_HOSTS.has(host)) {
      return `${PINATA_IPFS_GATEWAY}/${pathMatch[1]}${u.search || ""}`;
    }
    const subdomainCid = host.match(
      /^(.+)\.ipfs\.(dweb\.link|nftstorage\.link|w3s\.link)$/i,
    );
    if (subdomainCid?.[1]) {
      const rest = u.pathname && u.pathname !== "/" ? u.pathname.replace(/^\//, "") : "";
      const path = rest ? `${subdomainCid[1]}/${rest}` : subdomainCid[1];
      return `${PINATA_IPFS_GATEWAY}/${path}${u.search || ""}`;
    }
    return urlString;
  } catch {
    return urlString;
  }
}
